const FOCUSABLE_SELECTOR = 'input, button, select, textarea, [tabindex]';

export function focusControl(testId: string): void {
    const control = document.querySelector(`[data-testid="${testId}"]`);
    if (!control) {
        return;
    }
    control.scrollIntoView({ block: 'center', behavior: 'smooth' });
    const focusable = control.matches(FOCUSABLE_SELECTOR) ? control : control.querySelector(FOCUSABLE_SELECTOR);
    if (focusable instanceof HTMLElement) {
        focusable.focus();
    }
}
